if (!Foundation.MOBILE) {
    /**
     * @deprecated
     * @constructor
     * @extends {Foundation.View.Desktop.Spinner}
     */
    Foundation.Spinner = function () {
        var args = Array.prototype.slice.call(arguments, 0);
        Foundation.View.Desktop.Spinner.apply(this, args);
    };
    Foundation.inherit(Foundation.Spinner, Foundation.View.Desktop.Spinner);

    // ---------------------------------------------------------------------

    window["Foundation"]["Spinner"] = Foundation.Spinner;
    window["Foundation"]["Spinner"].prototype["show"] = Foundation.Spinner.prototype.show;
    window["Foundation"]["Spinner"].prototype["hide"] = Foundation.Spinner.prototype.hide;
}
